// extracted by mini-css-extract-plugin
export default {"List":"List_List__dLw3B","Intro":"List_Intro__WOdld","Eyebrow":"List_Eyebrow__IvUSp","Title":"List_Title__lp0Yj","Description":"List_Description__G9Oh7","Count":"List_Count__h+uwY"};